import { Accordion, AccordionSummary, AccordionDetails, Typography, Box, Button, Stack, useMediaQuery, useTheme, Grow, Fade, Link } from '@mui/material';
import { setSearchArticlesButtonLabels, setSearchArticlesLoading, setSearchArticleResponse } from '../../redux/actions/searchActions';
import { setButtonLabels, setLoading, setArticleResponse } from '../../redux/actions/ticketActions';
import AutoFixNormalOutlinedIcon from '@mui/icons-material/AutoFixNormalOutlined';
import AutoFixHighOutlinedIcon from '@mui/icons-material/AutoFixHighOutlined';
import { getGPTAnswerForSearch } from '../../redux/actions/searchActions';
import SummarizeOutlinedIcon from '@mui/icons-material/SummarizeOutlined';
import { getAggregateDataForTicket } from '../../apis/ticketResearch';
import { getAggregateDataForSearch } from '../../apis/SearchResearch';
import { getGPTAnswer } from '../../redux/actions/ticketActions';
import { convertHTMLtoMarkdown } from '../../constants/utils';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect, useState } from 'react';
import GptSandboxDialog from './GptSandboxDialog';
import { useNavigate } from 'react-router-dom';


const RelevantArticles = ({ relevantArticles, isLoading, buttonLabels, articleResponses, loading, renderType, ticketDetails, userEmail, agentDetails, prismToken, orgId, queryText, ticketingSystem, subDomain }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const articleAnswerLoading = useSelector((state) => state.ticket.gptAnswerForArticlesLoading);
    const articleAnswer = useSelector((state) => state.ticket.gptAnswerForArticles);
    const searchAnswerLoading = useSelector((state) => state.search.gptAnswerForArticlesLoading);
    const searchArticleAnswer = useSelector((state) => state.search.gptAnswerForArticles);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const gptAnswerForArticlesLoading = renderType === 'ticket' ? articleAnswerLoading : searchAnswerLoading;
    const gptAnswerforArticles = renderType === 'ticket' ? articleAnswer : searchArticleAnswer;
    const [openGptSandboxDialog, setOpenGptSandboxDialog] = useState(false);
    const [gptSandboxDialogContent, setGptSandboxDialogContent] = useState("");
    const handleOpenGptSandboxDialog = () => setOpenGptSandboxDialog(true);

    const handleCloseGptSandboxDialog = () => {
        setOpenGptSandboxDialog(false);
        setGptSandboxDialogContent("");
    }

    useEffect(() => {
        setGptSandboxDialogContent(convertHTMLtoMarkdown(gptAnswerforArticles));
    }, [gptAnswerforArticles])

    const updateLoadingState = (aid, isLoading) => dispatch(renderType === "ticket" ? setLoading({ [aid]: isLoading }) : setSearchArticlesLoading({ [aid]: isLoading }));

    const updateResponseState = (response, aid, type) => {
        const action = renderType === "ticket" ? setArticleResponse : setSearchArticleResponse;
        dispatch(action({
            aid,
            type,
            response: response.data.answer
        }));
    };

    const setLabels = (aid, type) => {
        const actionType = renderType === "ticket" ? setButtonLabels : setSearchArticlesButtonLabels;
        const label = type === 'gptAnswer' ? 'View Answer' : 'View Summary';
        dispatch(actionType({
            [aid]: {
                ...buttonLabels[aid],
                [type]: label
            }
        }));
    };


    const handleArticleOperationClick = async (aid, type, title, source) => {
        updateLoadingState(aid, type)
        // Simulate an API call
        const payload = { "aid": aid, "source": source ?? "" };
        const operationType = type === 'gptAnswer' ? 'answer' : 'summarize';
        const functionToCall = renderType === "ticket"
            ? getAggregateDataForTicket({ ticketDetails, operation: "article_operation", agentDetails, userEmail, prismToken, orgId, type: operationType, body: payload, dispatch })
            : getAggregateDataForSearch({ ticketDetails, queryText, operation: "article_operation", agentDetails, userEmail, prismToken, orgId, type: operationType, body: payload, dispatch });

        try {
            const response = await functionToCall;
            if (response.status === 200) {
                setGptSandboxDialogContent(response.data.answer);
                updateResponseState(response, aid, type);
                setLabels(aid, type)
                updateLoadingState(aid, null);
                handleOpenGptSandboxDialog(true);
            }
        } catch (error) {
            console.error('Error fetching article data:', error);
            updateLoadingState(aid, null);
        }
    };

    const handleGPTClick = async () => {
        const action = renderType === "ticket"
            ? getGPTAnswer(subDomain, ticketingSystem, ticketDetails, "gptanswerforarticles", agentDetails, userEmail, prismToken, orgId, "ARTICLES")
            : getGPTAnswerForSearch(subDomain, ticketingSystem, queryText, ticketDetails, "gptanswerforarticles", agentDetails, userEmail, prismToken, orgId, "ARTICLES")

        await dispatch(action)
        handleOpenGptSandboxDialog(true);
    }

    const filteredArticles = relevantArticles.filter((article) => article?.response?.title && article?.engine === 'gpt');

    return (
        <Grow in={true} timeout={500}>
            <Accordion elevation={2} sx={{ borderRadius: 2, backgroundColor: '#f9f9fb' }}>
                <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: '#152938' }} />}>
                    <Box display="flex" flexDirection="column">
                        <Typography variant="h6" fontWeight="bold" color="#152938">Relevant Articles</Typography>
                        <Typography variant="body2" color="textSecondary" fontWeight={500}>{filteredArticles.length} Articles</Typography>
                    </Box>
                </AccordionSummary>

                <AccordionDetails>
                    <Stack spacing={2}>
                        {filteredArticles.map((item, index) => (
                            <Fade in={true} style={{ transitionDelay: `${index * 100}ms` }} key={index}>
                                <Box flexWrap={isMobile ? 'wrap' : 'nowrap'} sx={{ display: "flex", flexDirection: "column", justifyContent: "space-between", alignItems: "center", padding: 1.5, borderRadius: 2, backgroundColor: 'white', boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.1)' }}>
                                    <Box textAlign="center" sx={{ width: isMobile ? '100%' : '75%', mb: 1 }}>
                                        <Typography variant="subtitle1" fontWeight="bold" >
                                            {item?.response?.source ? (
                                                <Link href={item?.response?.source} target="_blank" rel="noopener noreferrer" underline="hover" >
                                                    {item?.response?.title}
                                                </Link>
                                            ) : (
                                                <strong>#{item?.response?.title}</strong>
                                            )}
                                        </Typography>
                                    </Box>
                                    <Box sx={{ display: "flex", justifyContent: "center", width: "100%", gap: "10px" }} >
                                        <Button variant="contained" color="inherit" loading={loading[item.response.aid] === "gptAnswer"} loadingPosition="end" startIcon={<AutoFixNormalOutlinedIcon />} onClick={() => handleArticleOperationClick(item.response.aid, 'gptAnswer', item?.response?.title, item?.response?.source)} sx={{ textTransform: "none" }} >
                                            GPT Answer
                                        </Button>
                                        <Button variant="contained" color="inherit" loading={loading[item.response.aid] === "summary"} loadingPosition="end" startIcon={<SummarizeOutlinedIcon />} onClick={() => handleArticleOperationClick(item.response.aid, 'summary', item?.response?.title, item?.response?.source)} sx={{ textTransform: "none" }} >
                                            Summary
                                        </Button>
                                    </Box>
                                </Box>
                            </Fade>
                        ))}

                        <Box display="flex" justifyContent="center">
                            <Button
                                variant="contained"
                                color="inherit"
                                onClick={() => {
                                    handleGPTClick();
                                }}
                                loading={gptAnswerForArticlesLoading}
                                loadingPosition="end"
                                sx={{ textTransform: "none" }}
                                startIcon={<AutoFixHighOutlinedIcon />}
                            >
                                GPT Answer From Relevant Articles
                            </Button>
                        </Box>
                    </Stack>
                    <GptSandboxDialog open={openGptSandboxDialog} onClose={handleCloseGptSandboxDialog} renderType={renderType} content={gptSandboxDialogContent} loading={gptAnswerForArticlesLoading} ticketingSystem={ticketingSystem} subDomain={subDomain} userEmail={userEmail} orgId={orgId} ticketDetails={ticketDetails} prismToken={prismToken} />
                </AccordionDetails>
            </Accordion>
        </Grow>
    )
}

export default RelevantArticles